'use strict';

var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");

/**
 * Configurazione di un campo di tipo input:text
 * 
 * @class
 * 
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {type} Valida
 */
function BSSPassword(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsspassword',
        template: require("./bsspassword.html"),
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsspassword'
            },
        }
    }));
};


module.exports = BSSPassword;